import script from "./CallbackModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CallbackModal.vue?vue&type=script&setup=true&lang=js"

import "./CallbackModal.vue?vue&type=style&index=0&id=522e65e8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522e65e8"]])

export default __exports__